import './Page3346Style.css';
import { FAILED_ICON } from '../common/failedIcon';

function Page3346Failed() {

  return (
    <div className="Aa3346">
      <div className='container'>
        <div className='form-content'>
          <div className='title'>
            <h4 id='headup-title'>Загрузка не завершена</h4>
          </div>
          <div className='form-content-top'>
            <div className='logo'><img alt='Failed' src={FAILED_ICON} /></div>
          </div>
          <div className='form-content-middle'>
            <div className='title'>
              <h3 id='title'>Операция не удалась. Попробуйте позже.</h3>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
}

export default Page3346Failed;
